import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {BuyBonusPopUpEvents} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusPopUp/BuyBonusPopUpEvents';
import {WinMeterEvents} from '@gongxigames/framework/slot/modules/winmeter/WinMeterEvents';
import {BuyPopUpView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusPopUp/BuyPopUpView';
import {BuyBonusButtonEvents} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonEvents';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {ModuleIsEnabledFilter} from '@gongxigames/framework/core';
import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {KeypadControlsEvents} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsEvents';
import {WaitingModule} from '@gongxigames/framework/slot/modules/waiting/WaitingModule';

export class BuyPopUpModule extends Module<BuyPopUpView, GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('BuyPopUpModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;

    protected setupStates(): void {
    }

    protected setupViews(): void {
        this.setView(BuyPopUpView.NAME);
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.on(BuyBonusButtonEvents.BUY_BONUS_BUTTON_CLICKED, this.onBuyBonusButtonClicked);
        this.on(LogicEvents.BUY_RESPONSE, this.onBuyResponseReceived);

        this.on(KeypadControlsEvents.TOTAL_BET_CHANGED, this.onBetChanged);
        this.on('General.Screen.ORIENTATION_CHANGED', this.onOrientationChanged);
        this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponseReceived);

        this.onView(BuyPopUpView.BUY_BUTTON_CLICKED, this.onByButtonClicked);
        this.onView(BuyPopUpView.BUY_POP_CLOSE_CLICKED, this.onBuyPopUpClosed);
        this.onView(BuyPopUpView.FADE_OUT_ANIMATION_FINISHED, this.onFadeOutAnimationFinished);
        this.onView(BuyPopUpView.BET_INC_BUTTON_CLICKED, this.onIncButtonClicked);
        this.onView(BuyPopUpView.BET_DEC_BUTTON_CLICKED, this.onDecButtonClicked);
        this.onView(BuyPopUpView.BUY_PUP_SHOWN, this.onBuyPopUpShown);
    }

    protected onBetChanged(): void {
        const logic = this.logic;

        this.updateBetButtons();
        this.view.updateBuyBonusData(logic.getTotalBet(), logic.getRubyCoinsToSpend());

        this.checkIfEnoughMoneyToBuy();
    }

    protected onSpinResponseReceived(): void {
        this.checkIfEnoughMoneyToBuy();
    }

    protected onOrientationChanged(): void {
        this.checkIfEnoughMoneyToBuy();
    }

    protected checkIfEnoughMoneyToBuy(): void {
        const logic = this.logic;

        if (logic.isBonusCanBeBought()) {
            this.view.enableBuyButton();
        } else {
            this.view.disableBuyButton();
        }
    }

    protected onBuyResponseReceived(): void {
        this.eventManager.emit('General.UI.ENABLE', UIDisableReason.OPENNED_POPUP);
        this.eventManager.emit(WaitingModule.HIDE_POPUP);
    }

    protected showWaitingPopUP(): void {
        this.eventManager.emit(WaitingModule.SHOW_POPUP);
        this.eventManager.emit('General.UI.DISABLE', UIDisableReason.OPENNED_POPUP);
    }

    protected onByButtonClicked(): void {
        this.showWaitingPopUP();
        this.eventManager.emit(WinMeterEvents.STOP);
        this.eventManager.emit(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED);
        this.eventManager.emit('General.UI.DISABLE', UIDisableReason.TRIGGERING_FEATURE);
    }

    protected onBuyBonusButtonClicked(): void {
        const logic = this.logic;

        if (logic.isBonusCanBeBought()) {
            this.view.enableBuyButton();
        } else {
            this.view.disableBuyButton();
        }

        this.view.updateBuyBonusData(logic.getTotalBet(), logic.getRubyCoinsToSpend());
        this.view.playAnimation();
        this.eventManager.emit('General.UI.DISABLE', UIDisableReason.OPENNED_POPUP);
    }

    protected onBuyPopUpClosed(): void {
        this.eventManager.emit(BuyBonusPopUpEvents.BUY_POP_UP_CLOSED);
    }

    protected onFadeOutAnimationFinished(): void {
        this.eventManager.emit(BuyBonusPopUpEvents.FADE_OUT_ANIMATION_FINISHED);
        this.eventManager.emit('General.UI.ENABLE', UIDisableReason.OPENNED_POPUP);
    }

    protected onIncButtonClicked(): void {
        this.eventManager.emit(BuyBonusPopUpEvents.BET_INC_BUTTON_CLICKED);
    }

    protected onDecButtonClicked(): void {
        this.eventManager.emit(BuyBonusPopUpEvents.BET_DEC_BUTTON_CLICKED);
    }

    protected onBuyPopUpShown(): void {
        this.view.enableButtons();
        this.updateBetButtons();
    }

    public updateBetButtons(): void {
        const bets = this.logic.getBets();
        const betId = this.logic.betId;

        if (betId === 0) {
            this.view.disableBetDecButton();
        }

        if (betId === bets.length - 1) {
            this.view.disableBetIncButton();
        }
    }
}
